<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABPackagesList' }" class="mb-1 btn btn-sm btn-default float-right">
        <span>{{$t('buttons.backToList')}}</span>
      </router-link>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-card>
        <div class="card-body">
          <Form
              :handle-submit="handleSubmit"
              :handle-update-field="updateField"
              :values="item"
              :violations="violations">
          </Form>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Form from './Form'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },

  watch: {
    'created' (val) {
      if (val) {
        this.reset()
        this.$router.push({ name: 'EXABPackagesList' })
      }
    }
  },

  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABPackagesCreate')
  },

  computed: {
    ...mapGetters({
      created: 'packages/create/getCreated',
      item: 'packages/create/getItem',
      violations: 'packages/create/violations'
    })
  },

  beforeDestroy () {
    this.reset()
  },

  methods: {
    handleSubmit () {
      this.create(this.item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    },
    ...mapActions({
      create: 'packages/create/create'
    }),
    ...mapMutations({
      reset: 'packages/create/reset'
    })
  }
}
</script>
